import { createContext, useContext } from "react";
import { useHomeContext } from "./HomeContext";

interface IAssetState {
    assets: { name: string; value: number; percentage: number; color: string; hoverColor: string; }[];
    isLoading: boolean;
}

interface IAssetContext extends IAssetState {
}

interface IAssetProviderProps {
    children: React.ReactNode;
}

const AssetContext = createContext<IAssetContext|null>(null);

const AssetProvider = ({ children }: IAssetProviderProps) => {
    const homeContext = useHomeContext();
    const documentStyle = getComputedStyle(document.documentElement);

    const assets = [
        {
            name: "Renda fixa",
            value: homeContext.wallet?.fixedIncomeTotalValue ?? 0,
            percentage: homeContext.wallet?.fixedIncomeTotalPercentage ?? 0,
            color: documentStyle.getPropertyValue('--fixed-income-color'),
            hoverColor: documentStyle.getPropertyValue('--fixed-income-color-light')
        },
        {
            name: "Renda variável",
            value: homeContext.wallet?.variableIncomeTotalValue ?? 0,
            percentage: homeContext.wallet?.variableIncomeTotalPercentage ?? 0,
            color: documentStyle.getPropertyValue('--variable-income-color'),
            hoverColor: documentStyle.getPropertyValue('--variable-income-color-light')
        },
        {
            name: "Em caixa",
            value: homeContext.wallet?.cashUserTotalValue ?? 0,
            percentage: homeContext.wallet?.cashUserTotalPercentage ?? 0,
            color: documentStyle.getPropertyValue('--cashflow-color'),
            hoverColor: documentStyle.getPropertyValue('--cashflow-color-light')
        },
        {
            name: "Imóveis",
            value: homeContext.wallet?.propertiesTotalValue ?? 0,
            percentage: homeContext.wallet?.propertiesTotalPercentage ?? 0,
            color: documentStyle.getPropertyValue('--properties-color'),
            hoverColor: documentStyle.getPropertyValue('--properties-color-light')
        },
        {
            name: "Veículos",
            value: homeContext.wallet?.vehiclesTotalValue ?? 0,
            percentage: homeContext.wallet?.vehiclesTotalPercentage ?? 0,
            color: documentStyle.getPropertyValue('--vehicles-color'),
            hoverColor: documentStyle.getPropertyValue('--vehicles-color-light')
        }
    ];

    return (
        <AssetContext.Provider value={{ assets, isLoading: homeContext.isLoading }}>
            {children}
        </AssetContext.Provider>
    );
}

const useAssetContext = () => {
    const context = useContext(AssetContext);

    if (!context)
        throw new Error(`AssetContext cannot be null`);

    return context;
}

export { AssetProvider, useAssetContext }
